<template>
	<section>
		<!--工具条-->
		<el-col :span="24" class="toolbar" style="padding-bottom: 0px;">
			<el-form :inline="true" :model="confs.filters">
				<el-form-item v-for="item in confs.query">
					<el-input v-if="item.elType=='el-input'" v-model="confs.filters[item.key]" :placeholder="item.title"></el-input>
					<el-select v-else-if="item.elType=='el-select'" filterable 
						v-model="confs.filters[item.key]" :placeholder="item.title" class="h-m-select">
						<el-option v-for="selectItem in confs.selectList[item.listkey].data" 
							:key="selectItem[item.opkey]" :label="selectItem[item.opval]" 
							:value="selectItem[item.opkey]">
						</el-option>
					</el-select>
					<el-date-picker v-else-if="item.elType=='el-date-picker'" 
						v-model="confs.filters[item.key]" value-format="yyyy-MM-dd"
						:width="100" type="date" :placeholder="item.title"
					   />
				</el-form-item>
				<el-form-item v-for="item in confs.queryCheckBoxList">
					<el-checkbox v-model="confs.filters[item.key]">{{item.label}}</el-checkbox>
				</el-form-item>
				<el-form-item>
					<el-button type="primary" icon="el-icon-search" @click="getLists">搜索</el-button>
				</el-form-item>
				<el-form-item>
					<el-button type="info" plain @click="cleanQuery">清空条件</el-button>
				</el-form-item>
				<el-form-item v-for="item in confs.btnList">
					<el-button type="primary" @click="clickBtnList(item.acturl)">{{item.label}}</el-button>
				</el-form-item>
			</el-form>
		</el-col>
		<!--列表-->
		<el-table :data="datalist" border stripe highlight-current-row v-loading="listLoading" style="width:90%;" height="500">
			<el-table-column v-for="item in confs.tables" v-if="checkShow(item.flagModel)" :prop="item.prop" :label="item.label" :width="item.minWidth">
				<template slot-scope="scope">
					<div v-if="item.showLab">{{showLabs(scope.row[item.prop],item.listkey,item.opkey,item.opval)}}</div>
					<div v-else-if="item.showLabStr">
						<div v-for="labItem in item.showLabStrs">
							<div v-if="labItem.showLab">
								<font size="9" color="#902392">
								{{labItem.qz}}
								{{showLabs(scope.row[labItem.key],labItem.listkey,labItem.opkey,labItem.opval)}}
								</font>
							</div>
							<div v-else>{{labItem.qz}}{{scope.row[labItem.key]}}</div>
						</div>
					</div>
					<div v-else-if="item.isBtn">
						<el-button type="success" plain  round size="mini" @click="btnClickRow(scope.row,item)">{{item.btnName}}</el-button>
					</div>
					<div v-else-if="item.isjs">
						{{callJsBfb(scope.row[item.param1],scope.row[item.param2])}}
					</div>
					<div v-else>{{scope.row[item.prop]}}</div>
				</template>
			</el-table-column>
		</el-table>
		
		
	</section>
</template>
<script>
	import util from '../../common/js/util'
	import { getListPage, delData, saveData } from '../../api/api';
	export default {
		data() {
			return {
				testStr:'',
				cfids:'',
				confs:{},
				datalist: [],
				total: 0,
				pagesize:20,
				page: 1,
				listLoading: false,
				/////////////Form 表单
				editformtitle:'',//form编辑名称
				editFormVisible: false,//编辑界面是否显示
				editLoading: false
			}
		},
		methods: {
			clickBtnList:function(actUrl){
				let para = Object.assign({}, this.confs.filters);
				para.actionurl= actUrl ;				
				this.listLoading = true;
				getListPage(para).then((res) => {
					this.$message({message: res.data.message,type: res.data.type});
					this.getLists();
				});
			},
			checkShow:function(checkShowFlag){
				if(checkShowFlag==undefined) return true ;
				try{
					return this.confs.filters[checkShowFlag];
				}catch(e){}				
				return true ;
			},
			callJsBfb:function(para1,para2){
				try{
					if(para2==0) return "-";
					var reData = para1*100/para2 ;
					return reData.toFixed(2) + "%"; 
				}catch(e){
				}
				return "-";
			},
			tableBtnClick:function(index,row){
				try{
					console.log(this.confs.tableBtn.url);
					let para = {
						actionurl:this.confs.tableBtn.url,
						id:row.id
					};
					getListPage(para).then((res) => {
						this.$message({message: res.data.message,type: "success"});
					});
				}catch(e){}				
			},
			btnClickRow:function(rows,colItem){
				//console.log(JSON.stringify(colItem));
				console.log(colItem.isPush);
				if(colItem.isPush) {
					this.$router.push(colItem.goUrl+"id="+rows.id);
				}else{
					//api/control/createXls
					let paras = "";//colItem.goUrl+ "?service_code="+row.service_code+"&entime="+row.entime;
					//for (var key in colItem.paramKeys) {
					//	paras = paras + key+"="+rows[key]+"&";
					//}
					for (let i = 0; i < colItem.paramKeys.length; i++) {
						//console.log(jsonArray[i].name, jsonArray[i].age);
						var key = colItem.paramKeys[i] ;
						paras = paras + key+"="+rows[key]+"&";
					}
					if(paras.length>2){
						paras = paras.substring(0,paras.length-1);
					}
					paras = colItem.goUrl + "?" + paras ;
					console.log(paras);
					window.open(paras);
				}
			},
			cleanQuery:function(){
				var index = 0 ;
				for(let item of this.confs.query){
					this.confs.filters[item.key] = '';
					index ++ ;
					if(index>5) break ;
				}
			},
			isObject:function(value) {
			  return typeof value === 'object' && value !== null;
			},
			clickClose:function(){},
			showLabs:function(keystr,listkey,opkey,opval){
				let reStr = '';
				if(!this.isObject(this.confs.selectList[listkey])) return keystr;
				if(!this.isObject(this.confs.selectList[listkey].data)) return keystr;
				for (var item of this.confs.selectList[listkey].data) {
					//console.log(item[opkey]+'='+item[opval]+','+keystr);
					if(item[opkey]==keystr) {
						reStr = item[opval];
						break ;
					}
				}
				return reStr ;
			},
			getConf:function(){
				let para = {actionurl:'default/getCfs','sqlid':'getcf',id:this.cfids};
				this.listLoading = true;
				getListPage(para).then((res) => {
					if(!util.checkLogOut(this,res.data)){
						this.confs = res.data.confs;
						if(this.confs.isdebug){
							console.log("confs.tables="+this.confs.tables.length);
						}
						//初始化时间
						try{
							if(this.isObject(this.confs.initTimes)){
								for (let i = 0; i < this.confs.initTimes.length; i++) {
									this.confs.filters[this.confs.initTimes[i]] = util.formatDate.getdatestr(-1, 'yyyy-MM-dd');
								}
							}
						}catch(ee){}
						/////////////
						if(this.isObject(this.confs.selectList)){
							for (let [key, value] of Object.entries(this.confs.selectList)) {
								//console.log("key="+key+",,,"+value);
								this.getLabList(key,value);
							}
						}
						//准备获取list
						this.getLists();
					}
					this.listLoading = false;
				});
			},
			getLabList:function(keyName,objJson){
				let para = {actionurl:objJson.acturl,sqlid:objJson.sqlid,code:objJson.code};
				getListPage(para).then((res) => {
					if(!util.checkLogOut(this,res.data)){
						this.confs.selectList[keyName].data = res.data.datas;
						console.log(this.confs.selectList[keyName].data);
					}
					//this.listLoading = false;
				});
			},
			getLists:function(){
				let para = Object.assign({}, this.confs.filters);
				para.page = this.page;
				para.pagesize = this.pagesize;
				para.actionurl='default/getListAll';
				para.sqlid=this.confs.sqls.query;
				para.runexec = 'joinGroupStr';
				
				this.listLoading = true;
				getListPage(para).then((res) => {
					if(!util.checkLogOut(this,res.data)){
						this.total = res.data.total;
						this.datalist = res.data.datas;
					}
					this.listLoading = false;
				});
			},
			handleCurrentChange:function(val){
				this.page = val;
				this.getLists();
			},
			isObjectExists:function(obj) {
			  return typeof obj !== 'undefined' && obj !== null;
			}
		},
		mounted() { 
			this.cfids = this.$route.query.cfids;
			this.getConf();
		}
	}	
</script>
<style scoped>
	.el-header {
	  background-color:#eceef3;
	  color: #409eff;
	  padding-left:50px;
	  text-align: left;
	  line-height: 60px;
	}
	.el-footer{
		padding-top:10px;
		position:absolute;
		bottom:0;
		width:100%;
		background:#f7f9fd;
		color:white;
	}
	.to-right{
		position: fixed;
		right: 20px;
	}
	.el-main {
	  margin-top: 60px; /* 头部高度 */
	  padding: 0px;
	  margin-right:20px;
	  margin-bottom:40px;
	}
	.box-card-edit{
		height:500px;
	}
</style>


// WEBPACK FOOTER //
// baseReport.vue?5e891e07